import { useTranslation } from 'react-i18next';
// import Checkbox from '@mui/material/Checkbox';
import { Button, useMediaQuery } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { FC } from 'react';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Typography from '@mui/material/Typography';
import theme from '../../../styles/theme';
import GuruImg from '../../../static/assets/guru_new_cut.png';

type CompleteButtonProps = {
	checked: boolean;
	disabled?: boolean;
	taskName: string;
	handleChange: () => void;
	containRequiredQuiz: boolean;
	isQuizCompleted: boolean;
};

const CompleteButton: FC<CompleteButtonProps> = ({
	checked,
	handleChange,
	disabled,
	taskName,
	containRequiredQuiz,
	isQuizCompleted,
}) => {
	const { t } = useTranslation();
	const label = checked ? t('uncompleteTask') : t('completeTask');
	const isMobile = useMediaQuery('(max-width:400px)');
	// const inputProps = { inputProps: { 'aria-label': label } };
	const completedLabel = checked ? 'taskIsCompleted' : 'markTaskAsCompleted';
	return (
		<div
			style={{
				backgroundColor: 'rgba(177, 177, 177, 0.1)',
				// position: 'relative',
				display: 'flex',
				flexDirection: isMobile ? 'column' : 'row',
				// justifyContent: 'space-between',
				margin: '30px 0',
				borderLeft: `4px ${theme.palette.primary.main} solid`,
				paddingLeft: '20px',
				borderRadius: '0 3px 3px 0',
			}}
		>
			<div style={{ paddingTop: '5px' }}>
				<img
					src={GuruImg}
					alt=""
					style={{ maxHeight: '100px', minWidth: '100px', objectFit: 'contain' }}
				/>
			</div>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					paddingLeft: '15px',
					padding: '19px 15px 20px 15px',
					gap: '10px',
				}}
			>
				<div
					style={{
						display: 'flex',
						justifyContent: 'left',
					}}
				>
					{containRequiredQuiz && !isQuizCompleted && !checked
						? t('finishQuizToCompleteTask')
						: t(completedLabel, { name: taskName })}
				</div>
				<div>
					<Button
						variant={!checked ? 'contained' : 'outlined'}
						size="large"
						disabled={
							!!disabled || (containRequiredQuiz && !isQuizCompleted && !checked)
						}
						onClick={handleChange}
						sx={{ width: 'auto' }}
						disableElevation
					>
						<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
							{!checked ? <CheckBoxOutlineBlankIcon /> : <CheckBoxIcon />}

							{label}
						</div>
						{/* <FormControlLabel
						control={
							<Checkbox
								{...inputProps}
								// defaultChecked
								disabled={
									!!disabled || (containRequiredQuiz && !isQuizCompleted && !checked)
								}
								sx={{
									'& .MuiSvgIcon-root': { fontSize: 28 },
								}}
								checked={checked}
								onChange={handleChange}
							/>
						}
						label={
							<Typography variant="body1">
								<span style={{ fontWeight: 600 }}>{label} </span>
							</Typography>
						}
					/> */}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default CompleteButton;
